import { render, staticRenderFns } from "./ComplaintDetailForm.vue?vue&type=template&id=09ae39ee"
import script from "./ComplaintDetailForm.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports